import { useEffect } from 'react';
import useTimelineContext from "./useTimelineContext.js";
import ResourceTimelineDataSet from "../dataset/ResourceTimelineDataset.js";
export default function useResourceDataset(opts) {
  const {
    path
  } = opts;
  const {
    addDataset,
    range,
    rsrcDelegate
  } = useTimelineContext();
  useEffect(() => {
    const dataset = new ResourceTimelineDataSet({
      path: path.name,
      range,
      timeAttributePath: 'createdAt',
      rsrcDelegate
    });
    addDataset(path.name, dataset);
  }, [addDataset, path.name, range, rsrcDelegate]);
}